export let InboxNotificationType;

(function (InboxNotificationType) {
  InboxNotificationType["Vinted"] = "vinted";
  InboxNotificationType["Braze"] = "braze";
})(InboxNotificationType || (InboxNotificationType = {}));